import React, { useState, useEffect, useCallback } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import { fetchData, postData } from "../../services/apiServices";
import debounce from "lodash/debounce";

const GameHistoryData = () => {
  const [modal, setModal] = useState(false);
  const [search, setSearch] = useState("");
  const [userType, setUserType] = useState("all");
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [newUser, setNewUser] = useState({
    email: "",
    password: "",
    username: "",
  });
  const [viewModal, setViewModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [formData, setFormData] = useState({});
  const [saving, setSaving] = useState(false);

  const openViewModal = (row) => {
    setSelectedAccount(row);
    setFormData(row);
    setViewModal(true);
  };
  const columns = [
    {
      name: "User",
      selector: (row) => row.user_name,
      sortable: true,
      cell: (row) => (
        <div>
          <div className="fw-bold">{row.user_name}</div>
          <small className="text-muted">ID: {row.userid}</small>
        </div>
      ),
    },
    {
      name: "Game Title",
      selector: (row) => row.game_title,
      sortable: true,
    },
    {
      name: "Game ID",
      selector: (row) => row.game_id,
      sortable: true,
    },
    {
      name: "Start Time",
      selector: (row) => new Date(row.game_start_date).toLocaleString(),
      sortable: true,
    },
  ];

  const getData = async (page, searchQuery = "") => {
    setPending(true);
    try {
      // Pass search query as a parameter object
      const params = {
        page,
        limit: perPage,
        search: searchQuery,
      };

      const response = await fetchData("api/admin/gamehistory", params);
      if (response && response.status && response.data) {
        let sortedData = response.data;
        if (searchQuery) {
          sortedData = sortedData.sort((a, b) => {
            const aUsername = (a.username || "").toLowerCase();
            const bUsername = (b.username || "").toLowerCase();
            const aEmail = (a.email || "").toLowerCase();
            const bEmail = (b.email || "").toLowerCase();
            const searchLower = searchQuery.toLowerCase();

            // Exact matches come first
            if (aUsername === searchLower || aEmail === searchLower) return -1;
            if (bUsername === searchLower || bEmail === searchLower) return 1;

            // Then starts with matches
            if (
              aUsername.startsWith(searchLower) ||
              aEmail.startsWith(searchLower)
            )
              return -1;
            if (
              bUsername.startsWith(searchLower) ||
              bEmail.startsWith(searchLower)
            )
              return 1;

            // Then includes matches
            const aIncludes =
              aUsername.includes(searchLower) || aEmail.includes(searchLower);
            const bIncludes =
              bUsername.includes(searchLower) || bEmail.includes(searchLower);
            if (aIncludes && !bIncludes) return -1;
            if (!aIncludes && bIncludes) return 1;

            return 0;
          });
        }

        setRows(sortedData);
        setTotalRows(response.pagination?.totalRecords || 0);
      } else {
        setRows([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setRows([]);
      setTotalRows(0);
    } finally {
      setPending(false);
    }
  };

  const debouncedSearch = useCallback(
    debounce((searchQuery) => {
      getData(1, searchQuery);
      setCurrentPage(1);
    }, 300), // Reduced debounce time for better responsiveness
    [perPage],
  );

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setSearch(searchValue);
    debouncedSearch(searchValue);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getData(page, search);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPending(true);
    setPerPage(newPerPage);
    try {
      const params = {
        page,
        limit: newPerPage,
        search,
      };
      const response = await fetchData("api/admin/gamehistory", params);
      if (response && response.data) {
        setRows(response.data);
        setTotalRows(
          response.pagination?.totalAccounts || response.data.length,
        );
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getData(1, "");
  }, []);
  const handleUpdateAccount = async () => {
    try {
      setSaving(true);
      await postData("api/admin/updateadminbankdetails", {
        accountId: selectedAccount._id,
        ...formData,
      });
      setViewModal(false);
      getData(currentPage, search);
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };
  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex gap-3 align-items-center">
            {/* <Input
              type="select"
              value={userType}
              onChange={handleUserTypeChange}
              style={{ width: "150px" }}
            >
              <option value="all">All Users</option>
              <option value="internal">Internal</option>
              <option value="external">External</option>
            </Input> */}
          </div>
          {/* <Button color="primary" onClick={toggleModal}>
            Create User
          </Button> */}
        </div>

        <DataTable
          columns={columns}
          data={rows}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          progressPending={pending}
          responsive
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 25, 30, 50, 100]}
        />
      </CardBody>
    </Card>
  );
};

export { GameHistoryData };
